export const fieldsQueryKeys = {
  all: ['fields'] as const,
  lists: () => [...fieldsQueryKeys.all, 'list'] as const,
  list: (filters: object) => [...fieldsQueryKeys.lists(), filters] as const,
  details: () => [...fieldsQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...fieldsQueryKeys.details(), id] as const,
};
